<template>
  <div class="">
    <h1 class="mb-8 font-bold text-3xl">
      <inertia-link class="kreditgenie-text-green hover:kreditgenie-text-green-hover" :href="route('pages')">Seiten</inertia-link>
      <span class="kreditgenie-text-green font-medium">/</span>
      {{ form.title }}
    </h1>
    <trashed-message v-if="page.deleted_at" class="mb-6" @restore="restore">
      Diese Seite wurde gelöscht.
    </trashed-message>
    <div class="bg-white rounded-md shadow overflow-hidden">
      <form @submit.prevent="update">
        <div class="p-8 -mr-6 -mb-8 flex flex-wrap">
          <text-input v-model="form.title" :error="form.errors.title" class="pr-6 pb-8 w-full lg:w-1/2" label="Title" />

          <quill-editor
            ref="myQuillEditor"
            v-model="form.content"
            :error="form.errors.content"
            class="pr-6 pb-8 mb-8 w-full lg:w-full"
            label="Inhalt"
          />

          <text-input v-model="form.seo_title" :error="form.errors.seo_title" class="pr-6 pb-8 w-full lg:w-full" label="SEO Title" />
          <text-input v-model="form.meta_keywords" :error="form.errors.meta_keywords" class="pr-6 pb-8 w-full lg:w-full" label="Meta keywords" />
          <text-input v-model="form.meta_description" :error="form.errors.meta_description" class="pr-6 pb-8 w-full lg:w-full" label="Meta description" />
          <select-input v-model="form.status" :error="form.errors.status" class="pr-6 pb-8 w-full lg:w-1/2" label="Status">
            <option value="draft" selected>Draft</option>
            <option value="publish">Publish</option>
          </select-input>
        </div>
        <div class="px-8 py-4 bg-gray-50 border-t border-gray-100 flex items-center">
          <button v-if="!page.deleted_at" class="text-red-600 hover:underline" tabindex="-1" type="button"
                  @click="destroy"
          >
            Löschen
          </button>
          <button v-if="page.deleted_at" class="text-green-600 hover:underline" tabindex="-1" type="button"
                  @click="restore"
          >
            Wiederherstellen
          </button>
          <loading-button :loading="form.processing" class="btn-green ml-auto" type="submit">
            Aktualisieren
          </loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import Layout from '@/Shared/Layout'
import LoadingButton from '@/Shared/LoadingButton'
import SelectInput from '@/Shared/SelectInput'
import TextInput from '@/Shared/TextInput'
import TrashedMessage from '@/Shared/TrashedMessage'

import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import { quillEditor } from 'vue-quill-editor'

export default {
  metaInfo() {
    return {
      title: `${this.form.title}`,
    }
  },
  components: {
    quillEditor,
    LoadingButton,
    SelectInput,
    TextInput,
    TrashedMessage,
  },
  layout: Layout,
  props: {
    page: Object,
    tinyMceApiKey: String,
  },
  remember: 'form',
  data() {
    return {

      form: this.$inertia.form({
        title: this.page.title,
        content: this.page.content,
        seo_title: this.page.seo_title,
        meta_keywords: this.page.meta_keywords,
        meta_description: this.page.meta_description,
        status: this.page.status,
      }),
    }
  },
  methods: {
    update() {
      this.form.put(this.route('pages.update', this.page.id))
    },
    destroy() {
      if (confirm('Möchten Sie diese Seite wirklich löschen?')) {
        this.$inertia.delete(this.route('pages.destroy', this.page.id))
      }
    },
    restore() {
      if (confirm('Möchten Sie diese Seite wirklich wiederherstellen?')) {
        this.$inertia.put(this.route('pages.restore', this.page.id))
      }
    },
  },
}
</script>
